import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LogOut } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "./ui/alert-dialog";

export default function MobileTopBar() {
  const { t } = useTranslation();
  const loc = useLocation();
  const nav = useNavigate();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  const showLogout = user && (loc.pathname.startsWith("/admin") || loc.pathname.startsWith("/worker"));

  return (
    <>
      <div className="mobile-top-bar flex items-center gap-3 px-4 py-3 md:hidden">
        <span className="grid h-8 w-8 shrink-0 place-items-center overflow-hidden rounded-full bg-[#050706] shadow-[0_4px_12px_rgba(28,69,50,0.18)]">
          <img src="/theuniversaltree-logo.jpeg" alt="" className="h-full w-full object-cover rounded-full" />
        </span>
        <h1 className="font-display text-base font-semibold text-[#1A1D1A] flex-1">{t("app.name")}</h1>
        {showLogout && (
          <button onClick={() => setOpen(true)} className="flex items-center gap-1.5 rounded-lg bg-red-50 text-red-600 hover:bg-red-100 transition-all px-3 py-2 text-xs font-semibold">
            <LogOut size={14} /> Log out
          </button>
        )}
      </div>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="rounded-xl max-w-sm">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-display text-lg text-[#1A1D1A]">Log out</AlertDialogTitle>
            <AlertDialogDescription className="text-sm text-[#646964]">
              Are you sure you want to log out?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="flex-row gap-2 sm:flex-row">
            <AlertDialogCancel className="rounded-lg h-11 text-sm flex-1">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={() => { logout(); nav("/"); }} className="rounded-lg h-11 text-sm bg-[#D9734E] hover:bg-[#C26240] text-white flex-1">
              Log out
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
